var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCompleteStud(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.991,
    height: 32.811,
    viewBox: "0 0 30.991 32.811",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12961",
    "data-name": "Group 12961",
    transform: "translate(-1780.555 -145)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12959",
    "data-name": "Group 12959"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_38",
    "data-name": "Union 38",
    d: "M5.9,11.562l-8-9.3L2.083-1.5H9.722L13.9,2.258ZM1.46,2.486,5.9,7.655l4.442-5.169-1.6-1.44H3.06Z",
    transform: "translate(1782.648 146.5)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12956",
    "data-name": "Group 12956",
    transform: "translate(1783.434 155.063)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_34",
    "data-name": "Line 34",
    d: "M.791,6.919-1.272,5.64,2.782-.8,4.845.484Z",
    transform: "translate(5.389 0.795)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_35",
    "data-name": "Line 35",
    d: "M2.782,6.919-1.272.484.791-.8,4.845,5.64Z",
    transform: "translate(1.272 0.795)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_35-2",
    "data-name": "Line 35",
    d: "M2.782,6.919-1.272.484.791-.8,4.845,5.64Z",
    transform: "matrix(0.848, 0.53, -0.53, 0.848, 5.224, 7.314)",
    fill: "#707070"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12960",
    "data-name": "Group 12960",
    transform: "translate(15 7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_38-2",
    "data-name": "Union 38",
    d: "M5.9,11.562l-8-9.3L2.083-1.5H9.722L13.9,2.258ZM1.46,2.486,5.9,7.655l4.442-5.169-1.6-1.44H3.06Z",
    transform: "translate(1782.648 146.5)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12956-2",
    "data-name": "Group 12956",
    transform: "translate(1783.434 155.063)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_34-2",
    "data-name": "Line 34",
    d: "M.791,6.919-1.272,5.64,2.782-.8,4.845.484Z",
    transform: "translate(5.389 0.795)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_35-3",
    "data-name": "Line 35",
    d: "M2.782,6.919-1.272.484.791-.8,4.845,5.64Z",
    transform: "translate(1.272 0.795)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_35-4",
    "data-name": "Line 35",
    d: "M2.782,6.919-1.272.484.791-.8,4.845,5.64Z",
    transform: "matrix(0.848, 0.53, -0.53, 0.848, 5.224, 7.314)",
    fill: "#707070"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleteStud);
export default __webpack_public_path__ + "static/media/complete__stud.b60f71ffd6e4d65a16efd0c6628dcd8b.svg";
export { ForwardRef as ReactComponent };